// 引入客服信息区域
import ServiceInformation from '../ServiceInformation/ServiceInformation.vue'
export default {
    data() {
        return {
            //项目包id
            id: '',
            //项目包数据
            projectList: [],
            //控制上面tab的切换
            isTab: 1,
            // 当前用户的项目数据
            tableData: [],
            // 所有项目数据
            allTableData: [],
            // 轮播图数据
            bannerList: [],
            // 通知数据
            notices: [],
            // 指南数据
            newsList: [],
            imgUrl: this.imgUrl,
            bannerUrl: this.bannerUrl,
            headerImg: '',
            // 店铺id
            shop_id: '',
            allUrl: '',
            baseUrl: this.baseUrl
        }
    },
    methods: {
        // 获取项目包数据
        getPackage() {
            this.$post('package/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 9999,
                id: this.id
            }).then(res => {
                this.projectList = res.data.result.data[0];
            })
        },

        // 获取轮播图
        getBanner() {
            this.$post('product_small_banner/search', {
                offset: 0,
                length: 9999,
                package_id: this.id
            }).then(res => {
                this.bannerList = res.data.result.data
            })
        },

        // 获取通知公告
        getNotices() {
            this.$post('product_notices/search', {
                offset: 0,
                length: 3,
                package_id: this.id
            }).then(res => {
                this.notices = res.data.result.data
            })
        },

        // 获取新闻
        getNews() {
            this.$post('product_news/search', {
                offset: 0,
                length: 3,
                package_id: this.id
            }).then(res => {
                this.newsList = res.data.result.data
            })
        },


        // 跳转到项目学习页
        toProjectStudy(res) {
            // // console.log('点击', res)
            this.$toClass(res.product_id, res.is_project)
            // let address = this.$router.resolve({
            //       path: '/lessonstudy',
            //       query: {
            //       }
            //   });
            //   window.open(address.href,"_blank");
        },
        //改变控制切换栏的变量
        // changeTab() {
        //     // console.log(this.isTab)
        // },

        //请求本人在这个项目包已经购买的项目
        hadBuyPackageProject() {
            //请求给后台的数据
            let data = {
                token: this.$store.state.id,
                package_id: this.id,
                offset: 0,
                length: 999,
            }
            this.$post("purchased/search_by_userId_and_packageId", data).then(res => {
                // // console.log('444', res.data.result.data);
                this.tableData = res.data.result.data;
            })
        },
        //请求平台所有项目
        allPackageProject() {
            let data = {
                package_id: this.id,
                length: 999,
                offset: 0
            }
            this.$post("package_product/search", data).then(res => {
                // // console.log('all', res.data.result.data)
                this.allTableData = res.data.result.data
            })
        },

        // 点击通知或指南进行跳转到详情页面
        handleClick(type, item) {
            this.$router.push({
                path: '/projectnews',
                query: {
                    id: item.id,
                    type: type
                }
            })
        },

        // 根据url获取项目包详情
        getPackageInfo(url) {
            this.$post('package/get_package', {
                url: url
            }).then(res => {
                // console.log('res', res)
                this.id = res.data.result.id
                this.shop_id = res.data.result.shop_id

                // 获取店铺详情 
                this.getShopInfo(res.data.result.shop_id)

                // 获取项目包相关数据
                this.getPackage()
                this.getBanner()
                this.getNotices()
                this.getNews()

                // 如果当前用户未登录（token为空），则显示所有项目，登录了则显示已参加的项目
                if (this.$isAbnormal(this.$store.state.id)) {
                    this.allPackageProject()
                } else {
                    this.hadBuyPackageProject()
                }
            })
        },

        // 根据id获取项目包详情
        getPackageById(id) {
            this.$post('package/get_package', {
                id: id
            }).then(res => {
                // console.log('res', res)
                this.id = res.data.result.id
                this.shop_id = res.data.result.shop_id

                // 获取店铺详情 
                this.getShopInfo(res.data.result.shop_id)

                // 获取项目包相关数据
                this.getPackage()
                this.getBanner()
                this.getNotices()
                this.getNews()

                // 如果当前用户未登录（token为空），则显示所有项目，登录了则显示已参加的项目
                if (this.$isAbnormal(this.$store.state.id)) {
                    this.allPackageProject()
                } else {
                    this.hadBuyPackageProject()
                }
            })
        },

        // 根据shop_id获取店铺详情
        getShopInfo(shop_id) {
            this.$post('shops/get', {
                id: shop_id
            }).then(res => {
                this.$store.state.store = res.data.result;
                sessionStorage.setItem("store", JSON.stringify(this.$store.state.store))
            })
            // 将辅导员的token从浏览器缓存中取出
            this.$store.state.instructor = sessionStorage.getItem("instructor")

            // 将店铺的信息从浏览器缓存中取出并转成对象存储在vuex
            this.$store.state.store = JSON.parse(sessionStorage.getItem("store"))

            // 如果用户token为空且浏览器缓存中存有tpid则进入
            if (!this.$store.state.id && sessionStorage.getItem("tpid")) {
                // 从浏览器缓存中获取tpid并赋值到用户token
                this.$store.state.id = sessionStorage.getItem("tpid")

                // 从浏览器缓存中获取tpname并赋值到用户姓名
                this.$store.state.name = sessionStorage.getItem("tpname")

                // 从浏览器缓存中获取tpuserId并赋值到用户userId
                this.$store.state.userId = sessionStorage.getItem("tpuserId")

                // 从浏览器缓存中获取tpshopid并赋值到店铺id
                this.$store.state.shopId = sessionStorage.getItem("tpshopid")
            }
        },

        // 自动登录用户
        userLogin() {
            let userId = this.$route.query.id

            // 路径参数带有userid，则登录用户
            if (!this.$isAbnormal(userId)) {
                this.$post('users/getTokenByUserId', {
                    user_id: userId
                }).then(res => {
                    this.$store.state.id = res.data.result.token;
                    this.$store.state.shopId = res.data.result.shop_id
                    this.$post('users/profile', {
                        token: this.$store.state.id
                    }).then(res => {
                        this.$store.state.userId = res.data.result.id
                        this.$store.state.name = res.data.result.name
                        sessionStorage.setItem("tpid", this.$store.state.id)
                        sessionStorage.setItem("tpname", this.$store.state.name)
                        sessionStorage.setItem('tpuserId', this.$store.state.userId)
                        sessionStorage.setItem('tpshopid', this.$store.state.shopId)
                    })
                })
            }
        }
    },
    created() {
        this.id = this.$route.query.package_id
        let package_id = this.$route.query.package_id
        // 根据项目包id获取项目包详情
        this.getPackageById(package_id)

        // document.title = '2019年廉江市小学幼儿园教师全员培训'

        // 线上
        // let url = window.location.href.split('/#')[0]
        // this.getPackageInfo(url)
        // this.allUrl = url

        // 本地测试
        // this.getPackageInfo('https://ljjs.ca163.net')
        // this.allUrl = 'http://tsjs-test.bayou-tech.cn'

        // this.userLogin()

        // this.id = this.$route.query.id
        // this.getPackage()
        // this.getBanner()
        // this.getNotices()
        // this.getNews()

        // // 如果当前用户未登录（token为空），则显示所有项目，登录了则显示已参加的项目
        // if (this.$isAbnormal(this.$store.state.id)) {
        //     this.allPackageProject()
        // } else {
        //     this.hadBuyPackageProject()
        // }

    },
    computed: {
        packageYear() {
            if (this.projectList.start_stydy_time !== null) {
                return String(this.projectList.start_stydy_time).substr(0, 4);
            }
        }
    },
    components: {
        ServiceInformation
    }
}
